import {
  REQUEST_GEOZONES,
  RESPONSE_GEOZONES,
  REQUEST_GEOZONES_FAILURE,
  REQUEST_CREATE_GEOZONES,
  RESPONSE_CREATE_GEOZONES,
  REQUEST_CREATE_GEOZONES_FAILURE,
  REQUEST_DELETE_GEOZONES,
  RESPONSE_DELETE_GEOZONES,
  REQUEST_DELETE_GEOZONES_FAILURE,
  REQUEST_UPDATE_GEOZONES,
  RESPONSE_UPDATE_GEOZONES,
  REQUEST_UPDATE_GEOZONES_FAILURE,
  SET_SELECT_GEOZONE,
  REQUEST_ADD_UNIT_TO_GEOZONE,
  RESPONSE_ADD_UNIT_TO_GEOZONE,
  REQUEST_ADD_UNIT_TO_GEOZONE_FAILURE,
  REQUEST_DELETE_UNIT_TO_GEOZONE,
  RESPONSE_DELETE_UNIT_TO_GEOZONE,
  REQUEST_DELETE_UNIT_TO_GEOZONE_FAILURE,
} from "../actions/geozoneActions";

import { states as queriesStates } from "./queriesStates";

const initialState = {
  dataState: queriesStates.NOT_REQUESTED,
  createDataState: queriesStates.NOT_REQUESTED,
  deleteDataState: queriesStates.NOT_REQUESTED,
  addUnitDataState: queriesStates.NOT_REQUESTED,
  deleteUnitDataState: queriesStates.NOT_REQUESTED,
  requestPocess: false,
  geozones: [],
  tempGeozone: null,
  selectGeozone: null,
  createdId: null,
};

const geozonesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECT_GEOZONE:
      return Object.assign({}, state, {
        dataState: queriesStates.READY,
        selectGeozone: action.selectGeozone,
      });

    //Получение списка
    case REQUEST_GEOZONES: {
      return Object.assign({}, state, {
        dataState: queriesStates.REQUEST,
        requestPocess: true,
      });
    }
    case RESPONSE_GEOZONES: {
      return Object.assign({}, state, {
        dataState: queriesStates.READY,
        geozones: action.data.geoZones,
        requestPocess: false,
      });
    }
    case REQUEST_GEOZONES_FAILURE: {
      return Object.assign({}, state, {
        dataState: queriesStates.FAILURE,
        requestPocess: false,
        errors: action.errors,
      });
    }

    //Создание
    case REQUEST_CREATE_GEOZONES: {
      return Object.assign({}, state, {
        createDataState: queriesStates.REQUEST,
        requestPocess: true,
        tempGeozone: action.data,
      });
    }
    case RESPONSE_CREATE_GEOZONES: {
      const tempGeozone = state.tempGeozone;
      tempGeozone.id = action.data.id;

      const geozones = Object.assign([], state.geozones).concat([tempGeozone]);

      return Object.assign({}, state, {
        createDataState: queriesStates.READY,
        geozones: geozones, 
        requestPocess: false,
        createdId: action.data.id,
      });
    }
    case REQUEST_CREATE_GEOZONES_FAILURE: {
      return Object.assign({}, state, {
        createDataState: queriesStates.FAILURE,
        requestPocess: false,
        errors: action.errors,
      });
    }

    //Удаление
    case REQUEST_DELETE_GEOZONES: {
      return Object.assign({}, state, {
        deleteDataState: queriesStates.REQUEST,
        requestPocess: true,
      });
    }
    case RESPONSE_DELETE_GEOZONES: {
      const geozones = Object.assign([], state.geozones).filter((item) => {
        return item.id !== action.data;
      });

      return Object.assign({}, state, {
        deleteDataState: queriesStates.READY,
        geozones: geozones,
        tempGeozone: null,
        requestPocess: false,
      });
    }
    case REQUEST_DELETE_GEOZONES_FAILURE: {
      return Object.assign({}, state, {
        deleteDataState: queriesStates.FAILURE,
        errors: action.errors,
        requestPocess: false,
      });
    }

    //Обновление
    case REQUEST_UPDATE_GEOZONES: {
      return Object.assign({}, state, {
        updateDataState: queriesStates.REQUEST,
        requestPocess: true,
        tempGeozone: action.data,
      });
    }
    case RESPONSE_UPDATE_GEOZONES: {
      const geozones = Object.assign([], state.geozones).map((item) => {
        if (item.id === action.data.id) {
          item = action.data;
        }

        return item;
      });

      return Object.assign({}, state, {
        updateDataState: queriesStates.READY,
        geozones: geozones,
        requestPocess: false,
      });
    }
    case REQUEST_UPDATE_GEOZONES_FAILURE: {
      return Object.assign({}, state, {
        updateDataState: queriesStates.FAILURE,
        errors: action.errors,
        requestPocess: false,
      });
    }

    //Добавление тс к геозоне
    case REQUEST_ADD_UNIT_TO_GEOZONE: {
      return Object.assign({}, state, {
        addUnitDataState: queriesStates.REQUEST,
        requestPocess: true,
      });
    }
    case RESPONSE_ADD_UNIT_TO_GEOZONE: {
      const geozone = Object.assign({}, state.selectGeozone);
      geozone.units.push(action.data);

      return Object.assign({}, state, {
        addUnitDataState: queriesStates.READY,
        selectGeozone: geozone,
        requestPocess: false,
        createdId: null,
      });
    }
    case REQUEST_ADD_UNIT_TO_GEOZONE_FAILURE: {
      return Object.assign({}, state, {
        addUnitDataState: queriesStates.FAILURE,
        errors: action.errors,
        requestPocess: false,
      });
    }

    ///Удаление тс из геозоны
    case REQUEST_DELETE_UNIT_TO_GEOZONE: {
      return Object.assign({}, state, {
        deleteUnitDataState: queriesStates.REQUEST,
        requestPocess: true,
      });
    }
    case RESPONSE_DELETE_UNIT_TO_GEOZONE: {
      const geozone = Object.assign({}, state.selectGeozone);
      geozone.units = geozone.units.filter((item) => {
        return item.id !== action.data.id;
      });

      return Object.assign({}, state, {
        deleteUnitDataState: queriesStates.READY,
        selectGeozone: geozone,
        requestPocess: false,
      });
    }
    case REQUEST_DELETE_UNIT_TO_GEOZONE_FAILURE: {
      return Object.assign({}, state, {
        deleteUnitDataState: queriesStates.FAILURE,
        errors: action.errors,
        requestPocess: false,
      });
    }

    default:
      return state;
  }
};

export default geozonesReducer;
